import Microgame from '../engine/Microgame.js';

export default class SoccerGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Football !`, en: `Soccer!`, es: `¡Fútbol!` },
            controls: { fr: `Glisse pour tirer et donner de l'effet au ballon`, en: `Swipe to shoot and curve the ball`, es: `Desliza para disparar y dar efecto al balón` },
            objective: { fr: `Marque un but sans te faire arrêter par le gardien`, en: `Score a goal past the goalkeeper`, es: `Marca un gol pasando al portero` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="m12 7-3.5 2.5v5L12 17l3.5-2.5v-5z"/><path d="m5.5 16 3-2.5"/><path d="m18.5 16-3-2.5"/><path d="M12 7V2"/><path d="m15.5 9.5 5-2"/><path d="m8.5 9.5-5-2"/></svg>`,
            actions: [
                { type: 'move', x: 50, y: 80, duration: 300 },
                { type: 'wait', duration: 500 },
                { type: 'tap', x: 50, y: 80, duration: 200 },
                { type: 'hold', x: 50, y: 80, duration: 800 },
                { type: 'wait', duration: 200 },
                { type: 'swipe', x: 50, y: 80, toX: 40, toY: 30, duration: 400 },
                { type: 'wait', duration: 800 },
            ],
            loopDuration: 3500
        };
    }
    constructor(engine) {
        super(engine);
        this.ball = null;
        this.goalie = null;
        this.goalArea = null;
        this.isShooting = false;

        // --- GAME PARAMETERS ---
        this.duration = 6000;
        this.baseBallSpeed = 600; // max speed px per second
        this.goalieSpeed = 20; // px per second
        this.aimSpeed = 0.8; // radians per second (scaled down for x4)
        this.powerSpeed = 0.8; // power units per second (scaled down for x4)
        // -----------------------

        this.ballSpeed = 0;
        this.ballVx = 0;
        this.ballVy = 0;

        // Aiming & Power State
        this.isAiming = true;
        this.isPowering = false;

        const maxAngle = Math.PI / 3;
        this.aimAngle = (Math.random() * maxAngle * 2) - maxAngle; // Randomize start angle (-PI/3 to PI/3)
        this.aimDir = Math.random() < 0.5 ? 1 : -1;

        this.power = 0; // 0 to 1
        this.powerDir = 1;

        this.arrow = null;
        this.powerBarFill = null;
        this.hasResolved = false;
    }

    setup() {
        this.engine.ui.instruction.textContent = "SHOOT!";

        // Field
        const field = document.createElement('div');
        field.style.position = 'absolute';
        field.style.width = '300px';
        field.style.height = '400px';
        field.style.top = '50%';
        field.style.left = '50%';
        field.style.transform = 'translate(-50%, -50%)';
        field.style.border = `2px solid ${this.primaryColor}`;
        field.style.background = 'rgba(0, 255, 0, 0.1)';
        this.container.appendChild(field);

        // Goal Area
        this.goalArea = document.createElement('div');
        this.goalArea.style.position = 'absolute';
        this.goalArea.style.top = '0';
        this.goalArea.style.left = '50%';
        this.goalArea.style.transform = 'translateX(-50%)';
        this.goalArea.style.width = '300px';
        this.goalArea.style.height = '10px';
        this.goalArea.style.background = this.primaryColor;
        this.goalArea.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        field.appendChild(this.goalArea);

        // Goalkeeper
        this.goalie = document.createElement('div');
        this.goalie.style.position = 'absolute';
        this.goalie.style.top = '40px';
        this.goalie.style.left = '130px'; // Center of 300px is 150, 150 - (40/2) = 130px
        this.goalie.style.width = '40px';
        this.goalie.style.height = '40px';
        this.goalie.style.background = this.secondaryColor;
        this.goalie.style.borderRadius = '5px';
        this.goalie.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        field.appendChild(this.goalie);

        // Ball
        this.ball = document.createElement('div');
        this.ball.style.position = 'absolute';
        this.ball.style.bottom = '20px';
        this.ball.style.left = '135px'; // Center of 300px is 150, ball is 30px -> 135
        this.ball.style.width = '30px';
        this.ball.style.height = '30px';
        this.ball.style.background = this.primaryColor;
        this.ball.style.borderRadius = '50%';
        this.ball.style.boxShadow = `0 0 10px ${this.primaryColor}`;
        field.appendChild(this.ball);

        // Aim Arrow
        this.arrow = document.createElement('div');
        this.arrow.style.position = 'absolute';
        this.arrow.style.bottom = '50px';
        this.arrow.style.left = '148px'; // 150 - 2
        this.arrow.style.width = '4px';
        this.arrow.style.height = '60px'; // Length of arrow
        this.arrow.style.background = this.secondaryColor;
        this.arrow.style.transformOrigin = 'bottom center';
        this.arrow.style.transform = `rotate(${this.aimAngle}rad)`;
        this.arrow.style.zIndex = '5';
        field.appendChild(this.arrow);

        // Power Bar
        const powerBar = document.createElement('div');
        powerBar.style.position = 'absolute';
        powerBar.style.bottom = '20px';
        powerBar.style.right = '10px';
        powerBar.style.width = '20px';
        powerBar.style.height = '100px';
        powerBar.style.border = `2px solid ${this.primaryColor}`;
        powerBar.style.background = 'rgba(0,0,0,0.5)';
        field.appendChild(powerBar);

        this.powerBarFill = document.createElement('div');
        this.powerBarFill.style.position = 'absolute';
        this.powerBarFill.style.bottom = '0';
        this.powerBarFill.style.left = '0';
        this.powerBarFill.style.width = '100%';
        this.powerBarFill.style.height = '0%';
        this.powerBarFill.style.background = this.secondaryColor;
        powerBar.appendChild(this.powerBarFill);

        // Input
        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e) {
        if (this.isAiming && this.active) {
            this.isAiming = false;
            this.isPowering = true;
        }
    }

    onUp(e) {
        if (this.isPowering && this.active && !this.isShooting) {
            this.isPowering = false;
            this.isShooting = true;

            // Calculate velocity
            const actualPower = Math.max(this.power, 0.2); // minimum power
            const speed = this.baseBallSpeed * (this.engine.speedMultiplier || 1) * actualPower;

            // Note: angle 0 is straight UP. Positive angle is to the right.
            this.ballVx = speed * Math.sin(this.aimAngle);
            this.ballVy = speed * Math.cos(this.aimAngle); // vy is positive "up" the screen here

            this.arrow.style.display = 'none'; // hide arrow
            this.engine.timer = Infinity; // Stop the countdown timer so the ball can travel
        }
    }

    update(dt) {
        if (!this.active || this.hasResolved) return;

        const maxAngle = Math.PI / 3; // 60 degrees

        if (this.isAiming) {
            // Oscillate Aim
            this.aimAngle += this.aimSpeed * this.aimDir * (dt / 1000) * (this.engine.speedMultiplier || 1);
            if (this.aimAngle > maxAngle) {
                this.aimAngle = maxAngle;
                this.aimDir = -1;
            } else if (this.aimAngle < -maxAngle) {
                this.aimAngle = -maxAngle;
                this.aimDir = 1;
            }
            this.arrow.style.transform = `rotate(${this.aimAngle}rad)`;
        }
        else if (this.isPowering) {
            // Oscillate Power
            this.power += this.powerSpeed * this.powerDir * (dt / 1000) * (this.engine.speedMultiplier || 1);
            if (this.power >= 1) {
                this.power = 1;
                this.powerDir = -1;
            } else if (this.power <= 0) {
                this.power = 0;
                this.powerDir = 1;
            }

            // Update power bar UI (change color based on power)
            this.powerBarFill.style.height = `${this.power * 100}%`;
            if (this.power > 0.8) this.powerBarFill.style.background = 'red';
            else if (this.power > 0.4) this.powerBarFill.style.background = 'orange';
            else this.powerBarFill.style.background = this.secondaryColor;
        }
        else if (this.isShooting) {
            // --- MOVE BALL ---
            let bLeft = parseFloat(this.ball.style.left);
            let bBottom = parseFloat(this.ball.style.bottom); // Bottom is used! bottom = 0 is bottom edge

            bLeft += this.ballVx * (dt / 1000);
            bBottom += this.ballVy * (dt / 1000); // going up means increasing bottom

            this.ball.style.left = `${bLeft}px`;
            this.ball.style.bottom = `${bBottom}px`;

            // Wall Bounces for Ball
            if (bLeft <= 0) {
                bLeft = 0;
                this.ballVx *= -1;
            } else if (bLeft >= 270) { // 300 - 30
                bLeft = 270;
                this.ballVx *= -1;
            }

            // --- MOVE GOALIE (TRACKING) ---
            let gLeft = parseFloat(this.goalie.style.left);
            const gCenter = gLeft + 20; // goalie is 40px wide
            const bCenter = bLeft + 15; // ball is 30px wide

            // Goalie moves towards ball X
            const dir = Math.sign(bCenter - gCenter);
            // Goalie is slightly faster at higher speeds to keep up, but imperfect tracking
            const actualGoalieSpeed = this.goalieSpeed * (this.engine.speedMultiplier || 1) * 1.5;

            gLeft += dir * actualGoalieSpeed * (dt / 1000);

            // Clamp goalie to goal area (full width 300px)
            if (gLeft < 0) gLeft = 0; // Goal is 300px
            else if (gLeft > 260) gLeft = 260; // 300 - 40

            this.goalie.style.left = `${gLeft}px`;

            // --- COLLISION LOGIC ---
            const bRect = this.ball.getBoundingClientRect();
            const gRect = this.goalie.getBoundingClientRect();
            const goalRect = this.goalArea.getBoundingClientRect();

            // Hit Goalkeeper exactly?
            if (this.isColliding(bRect, gRect)) {
                this.resolveGame(false);
                return; // Stopped by keeper
            }

            // Hit the Goal Line (Top of area)
            // Note: bRect.top decreasing means it's moving up visually. Goal area is top: 0
            if (bRect.top <= goalRect.bottom) {
                // Ball crossed the line, but is it inside the posts?
                if (bCenter >= 0 && bCenter <= 300) {

                    // PROBABILITY SAVE
                    // Distance from ball center to goalie center
                    const dist = Math.abs(bCenter - gCenter);

                    // If dist is small (keeper is close), high chance of save
                    // If dist is large, low chance
                    // Max dist is roughly 120 (width of goal)
                    let saveChance = 0;
                    if (dist < 40) { // close
                        saveChance = 0.8 - (dist / 40) * 0.8; // 80% if spot on, drops to 0% at 40px
                    }

                    if (Math.random() < saveChance) {
                        this.resolveGame(false); // "WHAT A SAVE!"
                        this.engine.ui.instruction.textContent = "SAVED!";
                    } else {
                        // GOAL!
                        this.resolveGame(true);
                    }
                } else {
                    // Missed wide
                    this.resolveGame(false);
                    this.engine.ui.instruction.textContent = "MISSED WIDE!";
                }
                return;
            }

            // Missed entirely (bounced back or went weird)
            if (bBottom > 400 || bBottom < 0) {
                this.resolveGame(false);
            }
        }
    }

    resolveGame(success) {
        this.hasResolved = true;
        // Visual pause before transitioning
        setTimeout(() => {
            if (success) this.win();
            else this.lose();
        }, 600);
    }

    isColliding(r1, r2) {
        return !(r2.left > r1.right ||
            r2.right < r1.left ||
            r2.top > r1.bottom ||
            r2.bottom < r1.top);
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
